export const getCategoryShortName = (categoryName) => {
    const partsCategoryName = categoryName.split(" / ")
    return partsCategoryName[partsCategoryName.length - 1]?.trim() || ""
}